export default {
  version: '0.21.5',
};



// WEBPACK FOOTER //
// ./app/config.js